import { constants } from "@qgiv/core-js";

const getEmailInitialValue = (registrationAccount) => {
    const {
        contact: { email },
    } = registrationAccount;

    return {
        Email: email,
    };
};

const getGlobalAccountActionInitialValue = (registrationAccount) => {
    const {
        form: { initialGlobalAccountAction },
    } = registrationAccount;

    return {
        Global_Account_Action: initialGlobalAccountAction,
    };
};

const getUniqueIdentifier = (registrationAccount) => {
    const {
        form: { initialGlobalAccountAction, uniqueIdentifier },
    } = registrationAccount;
    const {
        ENUMS: { GlobalAccountAction },
    } = constants;

    // If the user is viewing the Reset Password or the Activate Account page,
    // pass the Unique Identifier value to the form as it is required by the
    // backend when performing these actions
    if (
        initialGlobalAccountAction === GlobalAccountAction.ACTIVATE_ACCOUNT ||
        initialGlobalAccountAction === GlobalAccountAction.RESET_PASSWORD
    ) {
        return {
            Unique_Identifier: uniqueIdentifier,
        };
    }

    return {
        Unique_Identifier: "",
    };
};

// eslint-disable-next-line import/prefer-default-export
export const getInitialValues = (registrationAccount) => {
    const values = {
        ...getEmailInitialValue(registrationAccount),
        ...getGlobalAccountActionInitialValue(registrationAccount),
        ...getUniqueIdentifier(registrationAccount),
        Password_Confirm: "",
        Password: "",
    };

    return values;
};
